/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { PlayerInformationModel, PlayerInformationModelType } from './PlayerInformationModel'
import { PlayerInformationModelSelector } from './PlayerInformationModel.base'
import { RootStoreType } from './index'

/**
 * PlayerStatsBase
 * auto generated base class for the model PlayerStatsModel.
 */
export const PlayerStatsModelBase = ModelBase.named('PlayerStats')
  .props({
    __typename: types.optional(types.literal('PlayerStats'), 'PlayerStats'),
    allTimesBiggestHandWonCards: types.union(types.undefined, types.array(types.string)),
    allTimesBiggestHandWonName: types.union(types.undefined, types.string),
    allTimesBiggestWin: types.union(types.undefined, types.number),
    gamesPlayed: types.union(types.undefined, types.number),
    isActive: types.union(types.undefined, types.boolean),
    numberOfHands: types.union(types.undefined, types.number),
    numberOfHandsPlayed: types.union(types.undefined, types.number),
    numberOfHandsWon: types.union(types.undefined, types.number),
    playerId: types.union(types.undefined, types.string),
    playerInformation: types.union(
      types.undefined,
      types.late(() => PlayerInformationModel)
    ),
    playerName: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PlayerStatsModelSelector extends QueryBuilder {
  get allTimesBiggestHandWonCards() {
    return this.__attr('allTimesBiggestHandWonCards')
  }
  get allTimesBiggestHandWonName() {
    return this.__attr('allTimesBiggestHandWonName')
  }
  get allTimesBiggestWin() {
    return this.__attr('allTimesBiggestWin')
  }
  get gamesPlayed() {
    return this.__attr('gamesPlayed')
  }
  get isActive() {
    return this.__attr('isActive')
  }
  get numberOfHands() {
    return this.__attr('numberOfHands')
  }
  get numberOfHandsPlayed() {
    return this.__attr('numberOfHandsPlayed')
  }
  get numberOfHandsWon() {
    return this.__attr('numberOfHandsWon')
  }
  get playerId() {
    return this.__attr('playerId')
  }
  get playerName() {
    return this.__attr('playerName')
  }
  playerInformation(
    builder:
      | string
      | PlayerInformationModelSelector
      | ((selector: PlayerInformationModelSelector) => PlayerInformationModelSelector)
      | undefined
  ) {
    return this.__child('playerInformation', PlayerInformationModelSelector, builder)
  }
}
export function selectFromPlayerStats() {
  return new PlayerStatsModelSelector()
}

export const playerStatsModelPrimitives =
  selectFromPlayerStats().allTimesBiggestHandWonCards.allTimesBiggestHandWonName.allTimesBiggestWin.gamesPlayed.isActive
    .numberOfHands.numberOfHandsPlayed.numberOfHandsWon.playerId.playerName
